import API from '../../apis';
import {
  action,
  generateErrorAction
} from '../actions';
import actionTypes from './actionTypes';

export const fetchAllIntroducedCafes = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.introducedCafes
        .fetchAllIntroducedCafes(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(generateErrorAction(err, {
            failure: actionTypes.FETCH_INTRODUCED_CAFES_FAILED,
            reject: actionTypes.FETCH_INTRODUCED_CAFES_REJECT
          }));
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_INTRODUCED_CAFES_LOADING);
  const success = res => action(actionTypes.FETCH_INTRODUCED_CAFES_SUCCESS, res);

  return request();
};
export const fetchIntroducedCafeDetails = (id) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.introducedCafes
        .fetchIntroducedCafeDetails(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(generateErrorAction(err, {
            failure: actionTypes.FETCH_INTRODUCED_CAFE_DETAILS_FAILED,
            reject: actionTypes.FETCH_INTRODUCED_CAFE_DETAILS_REJECT
          }));
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_INTRODUCED_CAFE_DETAILS_LOADING);
  const success = res => action(actionTypes.FETCH_INTRODUCED_CAFE_DETAILS_SUCCESS, res);

  return request();
};


export const changeCafeStatus = (status, rejectReason, cafeId) => {
  const request = () => {
    return dispatch => {
      changeCafeStatus
      dispatch(loading());
      return API.introducedCafes
        .changeCafeStatus(status, rejectReason, cafeId)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(generateErrorAction(err, {
            failure: actionTypes.CHANGE_INTRODUCED_CAFE_STATUS_FAILED,
            reject: actionTypes.CHANGE_INTRODUCED_CAFE_STATUS_REJECT
          }));
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.CHANGE_INTRODUCED_CAFE_STATUS_LOADING);
  const success = res => action(actionTypes.CHANGE_INTRODUCED_CAFE_STATUS_SUCCESS, res);

  return request();
};